<template>
  <div>
    <div class="searchbox">
      <form action="#" method="get" class="form-inline form-float">
        <div class="form-group">
          <label for="a_name">可通过路段:</label>
          <input
            class="form-control"
            type="text"
            placeholder
            size="12"
            v-noBlankSpace
          />
        </div>
        <div class="form-group">
          <label for="a_name">车场ID:</label>
          <input
            class="form-control"
            type="text"
            placeholder
            size="12"
            v-noBlankSpace
          />
        </div>
        <div class="form-group">
          <label for="a_name">卡号查询:</label>
          <input
            class="form-control"
            type="text"
            placeholder
            size="12"
            v-noBlankSpace
          />
        </div>

        <div class="form-group others">
          <span class="search_btn">
            <button type="button" class="btn btn-primary" id="search_btn">
              查询
            </button>
          </span>

          <span class="add_btn">
            <button type="button" class="btn btn-default" id="add">
              添加
            </button>
          </span>
        </div>
      </form>
    </div>
    <div class="list-right">
      <el-table
        ref="table"
        border
        :data="tableListData"
        height="100%"
        :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
      >
        <el-table-column
          show-overflow-tooltip
          label="编号"
          prop="name"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="街道"
          prop="contact"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="路段"
          prop="mobile"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="车场ID"
          prop="address"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="卡号"
          prop="crtUserName"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="设备类型"
          prop="crtUserName"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="屏宽度"
          prop="crtUserName"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="屏长度"
          prop="crtUserName"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="控制卡类型"
          prop="crtUserName"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="设备状态"
          prop="crtUserName"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="添加时间"
          prop="crtUserName"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="最后通信时间"
          prop="crtUserName"
        ></el-table-column>
        <el-table-column show-overflow-tooltip label="操作">
          <template slot-scope="scope">
            <button class="edit operate-button" type="button">
              修改
            </button>
            <button class="delete operate-button" type="button">
              删除
            </button>
           
          </template>
        </el-table-column>
      </el-table>
    </div>
    <Page v-on:pagination="receivePaginationData"></Page>
  </div>
</template>
<script>
import Page from "../../commons/page.vue";
export default {
  data() {
    return {
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },

      tableListData: [],
      form: {
        id: "",
        name: "",
        contact: "",
        mobile: "",
        address: "",
        crtUserName: "",
      },

      search: {
        pageNumber: 1,
        pageSize: 10,
        name: "",
      },

      formLabelWidth: "100px",
    };
  },
  methods: {
    receivePaginationData(v1, v2) {},
  },

  components: {
    Page,
  },
};
</script>
